export enum AdmissionDocumentsEnums {
  AdmissionServiceArgeement = 'AdmissionServiceArgeement',
  FaceSheet = 'FaceSheet',
  FaceSheet2021 = 'FaceSheet2021',
  PatientEmergencyAndContactInfo = 'PatientEmergencyAndContactInfo',
  EmployeeBackgroundCheckResults = 'EmployeeBackgroundCheckResults',
  HomeSafetyAssessment = 'HomeSafetyAssessment',
  ReliaseOfInformationForm = 'ReliaseOfInformationForm',
  DirectCareWorkerStatusPolicy = 'DirectCareWorkerStatusPolicy',
  SignatureVerificationAndConfirmation = 'SignatureVerificationAndConfirmation',
  // MedicationProfile = 'MedicationProfile',
  // AcknowlegementOfNoticeOfTheMedicationProfile = 'AcknowlegementOfNoticeOfTheMedicationProfile',
  PersonalCareHhaCarePlan = 'PersonalCareHhaCarePlan',
  PersonalCareHhaCarePlan2021 = 'PersonalCareHhaCarePlan2021',
  HomemakerSupervisoryReport = 'HomemakerSupervisoryReport',
  AcknowlegementOfNoticeOfProhibition = 'AcknowlegementOfNoticeOfProhibition',
  AcknowlegementOfChapter = 'AcknowlegementOfChapter',
  AcknowlegementOfChapterV2 = 'AcknowlegementOfChapterV2',
  ConsumerServiceAgreement = 'ConsumerServiceAgreement',
  DischargeTransferSummaryForm = 'DischargeTransferSummaryForm',
  VerificationOfParticipantsRecordReview = 'VerificationOfParticipantsRecordReview',
  HealthShareExchangePrivacyForm = 'HealthShareExchangePrivacyForm',
}

export const EBC_DOCS_NAME = 'Employee background check results - employer and consumer agreement';

export enum AdmissionDocumentsNameEnums {
  AdmissionServiceArgeement = 'Admission Service Argeement',
  FaceSheet = 'Admission Face Sheet',
  FaceSheet2021 = 'Admission Face Sheet',
  PatientEmergencyAndContactInfo = 'Patient Emergency And Contact Information',
  EmployeeBackgroundCheckResults = 'Employee background check results - employer and consumer agreement',
  HomeSafetyAssessment = 'Home Safety Assessment',
  ReliaseOfInformationForm = 'Release Of Information Form',
  DirectCareWorkerStatusPolicy = 'Direct Care Worker Status Policy',
  SignatureVerificationAndConfirmation = 'Signature Verification And Confirmation',
  // MedicationProfile = 'MedicationProfile',
  // AcknowlegementOfNoticeOfTheMedicationProfile = 'AcknowlegementOfNoticeOfTheMedicationProfile',
  PersonalCareHhaCarePlan = 'Care Plan',
  PersonalCareHhaCarePlan2021 = 'Care Plan',
  HomemakerSupervisoryReport = 'Homemaker Supervisory Report',
  AcknowlegementOfNoticeOfProhibition = 'Acknowlegement Of Notice Of Prohibition',
  AcknowlegementOfChapter = 'Acknowlegement Of Chapter',
  AcknowlegementOfChapterV2 = 'Acknowlegement Of Chapter',
  ConsumerServiceAgreement = 'Consumer Service Agreement',
  DischargeTransferSummaryForm = 'Discharge Transfer Summary Form',
  VerificationOfParticipantsRecordReview = 'Verification Of Participants Record Review',
  HealthShareExchangePrivacyForm = 'Health Share Exchange Privacy Form',
}
